// Token do convite da carteira conjunta (ADR-021). Sai da URL assim que a página abre e fica só na sessão da aba,
// para sobreviver ao login ou ao cadastro sem aparecer no histórico. sessionStorage pode falhar (aba privada,
// armazenamento bloqueado): sem ele, a pessoa só precisa abrir o link do e-mail de novo depois de entrar.
const KEY = "fincontrol-pending-invite"

export const pendingInvite = {
  get(): string | null {
    try { return sessionStorage.getItem(KEY) } catch { return null }
  },
  save(token: string) {
    try { sessionStorage.setItem(KEY, token) } catch { /* segue sem guardar */ }
  },
  clear() {
    try { sessionStorage.removeItem(KEY) } catch { /* nada a limpar */ }
  },
}

/** Destino depois de entrar ou criar a conta: o convite pendente, se houver. */
export const afterLoginPath = () => (pendingInvite.get() ? "/invite" : "/dashboard")
